import { useMemo } from "react";
import { useRecoilValue } from "recoil";

import { BetCalculationsEnum, getBetCalculations } from "../../../../calculation";
import { useTranslation } from "src/hooks/translation";
import selectionsStore from "src/stores/selections";
import upperDataStore from "src/stores/upperData";
import Money from "src/common/components/money";
import { useConfig } from "src/hooks/config";
import mainStore from "src/stores/main";

interface IProps {
	stake: number;
}

const BetDetailsProfitBoost = ({ stake }: IProps) => {
	const t = useTranslation();
	const config = useConfig();
	const { betType, systemCombinationCount } = useRecoilValue(mainStore);
	const { selections } = useRecoilValue(selectionsStore);
	const { partnerConfig, currencyConfig } = useRecoilValue(upperDataStore);
	const { profitBoostPercent, isProfitBoost } = useRecoilValue(mainStore);

	const { possibleWin } = useMemo(
		() =>
			getBetCalculations([BetCalculationsEnum.PossibleWin], {
				config,
				partnerConfig,
				betType,
				stake: +stake,
				events: selections,
				systemCombinationCount,
				currencyConfig,
			}),
		[config, partnerConfig, stake, currencyConfig, betType, selections, systemCombinationCount]
	);

	if (!possibleWin || !profitBoostPercent) return null;

	const amount = ((possibleWin - stake) * profitBoostPercent) / 100;

	return isProfitBoost ? (
		<div className="B-betslip-bet-details-info-row">
			<p className="B-info-row-title">
				{t("Profit Boost")}:<span className="B-percent">{profitBoostPercent}%</span>
			</p>
			<p className="B-info-row-number">
				<Money amount={amount} />
			</p>
		</div>
	) : null;
};

export default BetDetailsProfitBoost;
